import { h, createContext } from "preact";
import { useState, useContext, useEffect } from "preact/hooks";
import AddressStep from "./components/addressStep/AddressStep";
import DebtStep from "./components/debtStep/DebtStep";
import OwnerStep from "./components/ownerStep/OwnerStep";
import SuccessStep from "./components/successStep/SuccessStep";
import { APARTMENT_FORM_TYPE } from "./ApartmentForm.types";
import { sendRequest } from "../../tools";

export default function ApartmentForm(props) {
  const FormContext = createContext();
  const { type } = props;
  function FormProvider({ children }) {
    const steps = [
      type === APARTMENT_FORM_TYPE.BUY ? "Купил квартиру" : "Продал квартиру",
      "Задолженность",
      "Смена НСИ",
      "Сохранено",
    ];

    const [currentStep, setCurrentStep] = useState(0);
    const [formData, setFormData] = useState({});
    console.log("formData", formData);
    
    useEffect(() => {
      if (currentStep == steps.length - 1) {
        submitData();
      }
    }, [currentStep]);

    const nextStep = (data) => {
      setFormData((prev) => ({ ...prev, ...data }));
      setCurrentStep((prev) => prev + 1);
    };

    const submitData = () => {
      formData.action = type;
      console.log("Submitting data:", formData);
      // Send data to the server
      sendRequest('/personal-data/send/', {body: formData, type: 'POST', headers: {contentType: false, processData: false}, showLoader: true})
      .then((data) => {
        if (data.status === 200) {
        } else {
          alert('Произошла неизвестная ошибка во время выполнения запроса.');          
        }
      });
    };

    return (
      <FormContext.Provider
        value={{
          setCurrentStep,
          setFormData,
          currentStep,
          nextStep,
          formData,
          steps,
          props,
        }}
      >
        {children}
      </FormContext.Provider>
    );
  }

  function FormSteps() {
    const { currentStep, nextStep, steps, props } = useContext(FormContext);
    return (
      <div style={{ maxWidth: "900px" }}>
        <div className="apartment-form__steps">
          {steps.slice(0, currentStep + 1).map((step, index) => (
            <span
              key={index}
              className={index === currentStep ? "active" : "completed"}
            >
              {step}
              {"  "}
              {index < currentStep && (
                <span className="apartment-form__steps-separator">—</span>
              )}
            </span>
          ))}
        </div>
        {currentStep === 0 && (
          <AddressStep
            type={type}
            onNext={nextStep}
            formContext={FormContext}
            props={props}
          />
        )}
        {currentStep === 1 && (
          <DebtStep type={type} onNext={nextStep} formContext={FormContext} />
        )}
        {currentStep === 2 && (
          <OwnerStep type={type} onNext={nextStep} formContext={FormContext} />
        )}
        {currentStep === 3 && <SuccessStep formContext={FormContext} />}
      </div>
    );
  }

  return (
    <FormProvider>
      <FormSteps />
    </FormProvider>
  );
}
